import { useContext, useState } from 'react';
import AutomatedAvatar from './AutomatedAvatar';
import StyledChip from './StyledChip';
import useRemoveAssignee from '../useRemoveAssignee';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';
import IsInTaskAttachmentViewContext from '@/components/perspectives/IsInTaskAttachmentViewContext';
import { type UserSummary } from '@/lib/types';
import { useTheme } from '@emotion/react';
import generateColorForName, {
  ColorDerivationStrategy,
} from '@/components/UserAvatar/generateColorForName';

type AssigneeProps = {
  user: UserSummary;
};

const Assignee = ({ user }: AssigneeProps) => {
  const portfolioIsReadonly = useIsPortfolioReadonly();
  const isInTaskAttachmentView = useContext(IsInTaskAttachmentViewContext);

  const [removing, setRemoving] = useState(false);
  const removeAssignee = useRemoveAssignee();

  const handleRemove = async (): Promise<void> => {
    setRemoving(true);

    await removeAssignee(user);

    setRemoving(false);
  };

  const chipColor = generateColorForName(
    user.name,
    ColorDerivationStrategy.MIDDLE_CHAR,
  );

  const theme = useTheme();
  const randomColorShade = theme.isDark ? 200 : 600;

  return (
    <StyledChip
      avatar={<AutomatedAvatar user={user} />}
      label={user.name}
      onDelete={
        !portfolioIsReadonly && !isInTaskAttachmentView
          ? handleRemove
          : undefined
      }
      disabled={removing}
      chipColor={chipColor[randomColorShade]}
    />
  );
};

export default Assignee;
